export class ProfileApi {
    /** @type {ServerData} */ #client;

    constructor(client) {
        this.#client = client;
    }

    getApartments() {
        return this.#client.get('/tenants/profile/apartments', {}, { throwError: true });
    }

    // NOTE: this is POC method, feel free to change or remove
    getApartmentInfo(buildingId, apartmentNumber) {
        return this.#client.get(`/tenants/profile/apartment/${buildingId}/${apartmentNumber}`, {}, { throwError: true });
    }

    /**
     * @param {string|number} buildingId
     * @param {string} apartmentNumber
     * @param {number} paymentId
     * @return Promise<{ invoiceUrl: string }>
     * */
    getPaymentInvoiceUrl(buildingId, apartmentNumber, paymentId) {
        return this.#client.get(`/tenants/profile/apartment/${buildingId}/${apartmentNumber}/payment/${paymentId}/invoice`, {}, { throwError: true });
    }

    /**
     * @param {string|number} buildingId
     * @param {string} apartmentNumber
     * @param {number} year
     * @param {number | null} [paymentPlanId=null]
     * @return {Promise<{ paymentPlans: object[] }>} TODO: add type here
     * */
    getActivePaymentPlans(buildingId, apartmentNumber, year, paymentPlanId = null) {
        return this.#client.get(`/tenants/profile/apartment/${buildingId}/${apartmentNumber}/payment-plan/all-active/${year}/${paymentPlanId ?? ''}`, {}, { throwError: true });
    }


    /**
     * @param {string | number} buildingId
     * @param {string} apartmentNumber
     * @param {number} year
     * */
    getApartmentPaymentsByMonth(buildingId, apartmentNumber, year) {
        return this.#client.get(`/tenants/profile/apartment/${buildingId}/${apartmentNumber}/paymentsByMonths/${year}`, {}, { throwError: true });
    }

}
